
import { Component, Vue } from 'vue-property-decorator'
import { Action, Getter } from 'vuex-class'
import { getAccountId, getCampaignId } from '@/service/storage'
import { RootStateMutations } from '@/store/mutations'
import References from '@/api/models/References'
import CampaignReferences from '@/api/models/CampaignReferences'

@Component({})
export default class StorageMixin extends Vue {
    @Getter('currentCampaign')
    readonly campaign!: number

    @Getter('currentAccount')
    readonly account!: number

    @Getter('references')
    references!: References

    @Getter('campaignReferences')
    campaignReferences!: CampaignReferences

    @Action('loadReferences')
    loadReferences!: () => Promise<void>

    @Action('loadCampaignReferences')
    loadCampaignReferences!: () => Promise<void>

    created () {
        if (!this.account) {
            const accountId = getAccountId() || 0
            if (!accountId) {
                this.$router.push({ name: 'accounts' })
            } else {
                this.$store.commit(RootStateMutations.setAccount, accountId)
            }
        }

        if (!this.campaign) {
            const campaignId = getCampaignId() || 0
            if (!campaignId) {
                this.$router.push({ name: 'account_campaigns' })
            }

            this.$store.commit(RootStateMutations.setCampaign, campaignId)
        }

        this.getSystemReferences()
        this.getCampaignReferences()
    }

    async getSystemReferences (): Promise<void> {
        if (!this.references.loaded) {
            await this.loadReferences()
        }
    }

    async getCampaignReferences (): Promise<void> {
        if (!this.campaignReferences.loaded) {
            await this.loadCampaignReferences()
        }
    }
}
